<template>

  <!-- Google Tag Manager (noscript) -->
  <noscript v-if="GTM_ID">
    <iframe :src="`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
  </noscript>
  <!-- End Google Tag Manager (noscript) -->
  <RouterView/>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'

const GTM_ID: string | undefined = import.meta.env.VITE_GTM_ID

useHead({
  title: 'Bistroo - Maakt iedere online bestelling makkelijk',
  meta: [
    {name: 'description', content: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.'},
    {name: 'viewport', content: 'width=device-width, initial-scale=1.0'},
    {name: 'charset', content: 'UTF-8'},
    {name: 'canonical', content: 'https://www.bistroo.nl'},

    {property: 'og:title', content: 'Maakt iedere online bestelling makkelijk'},
    {property: 'og:description', content: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.'},
    {property: 'og:image', content: 'https://www.bistroo.nl/images/business-portal/bistroo-zakelijk-og-image.jpg'},
    {property: 'og:type', content: 'website'},
    {property: 'og:url', content: 'https://www.bistroo.nl'},
    {property: 'og:site_name', content: 'Bistroo'},

    {name: 'twitter:title', content: 'Maakt iedere online bestelling makkelijk'},
    {name: 'twitter:description', content: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.'},
  ],
  link: [
    {rel: 'icon', href: '/favicon.ico'},
  ],
  script: [
    ...(GTM_ID ? [{
      innerHTML: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
      `,
    }] : []),
    {
      type: 'application/ld+json',
      innerHTML: `{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Maakt iedere online bestelling makkelijk",
        "description": "Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo."
      }`
    }
  ]
})
</script>

<style scoped>

</style>